import { StrapiMedia } from '@portals/api';

export type Project = {
	id: number;
	name: string;
	slug: string;
	image: StrapiMedia;
	is_private: boolean;
};
